import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { type AxiosError, type AxiosResponse } from 'axios';

import { patchData } from '@framework/api/apiCalls';
import { api } from '@framework/constants/endpoints';
import { ServerStateKeys } from '@framework/constants/serverStateKeys';

type StateEntry = {
    expiry: string;
    stateId: string;
    stateName: string;
    stateType: string;
    value: boolean | number | string;
};

type UserState = StateEntry | StateEntry[];

const pathStatesRequest = (state: UserState) => {
    const states = Array.isArray(state) ? state : [state];
    return patchData(api.userState(), { states });
};

const useUserStateMutate = (): UseMutationResult<AxiosResponse, AxiosError, UserState> => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: pathStatesRequest,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [ServerStateKeys.UserStates] });
        }
    });
};

export default useUserStateMutate;
